import { variables } from '../variables';
import MontserratRegular from '../../fonts/LegacyPM/Montserrat-Regular.woff2';
import MontserratItalic from '../../fonts/LegacyPM/Montserrat-Italic.woff2';
import Merriweather from '../../fonts/LegacyPM/Merriweather.woff2';

export const legacyPMColors = {
  // Primary colors
  colorPrimary: '#870012',
  colorPrimaryLight: '#DDD288',
  colorPrimaryDark: '#A47E25',
  colorProgressBarDefault: '#F4F4F4',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#f2545b',
  colorGrey: '#f5f5f5',

  // Button colors
  colorButtonPrimary: '#7B0A18',
  colorButtonPrimaryInactive: 'rgba(123, 10, 24, 0.5)',
  colorButtonPrimaryActive: '#54050F',
  colorButtonSecondary: '#F1F5F6', // don't use
  colorButtonSecondaryActive: '#E1E2E2F', // don't use

  // Icon
  colorCheckedIcon: 'green',
  colorSuccess: '#00876A',

  // Text
  colorTextPrimary: '#231F20', // blue
  colorTextSecondary: '#231F20', // semiDark
  colorTextOutline: '#14213D', // blueOutline
  colorTextLight: '#807F83', // light
  colorTextXLLight: '#595959', // XL light
  colorTextGrey: '#8E8E8E', // grey
  colorTextGrey5: '#394A64', // grey 5
  colorTextGrey6: '#293854', // grey6
  colorTextError: '#f2545b', // red
  colorLink: '#A47E25', // semiDark

  // Backgrounds
  colorBackgroundPrimary: '#ffffff', // white
  colorBackgroundPrimaryDark: '#F7F7F7', // whitish
  colorBackgroundSecondary: '#fafafa', // xlGrey
  colorBackgroundSecondaryLight: '#F1F5F6', // light grey
  colorBackgroundSecondaryDark: '#16191D', // dark
  colorBackgroundSecondaryDark1: '#ECECEC', // dark1
  colorBackgroundDropzone: '#f9f9f9', // grey2
  colorBackgroundModal: 'rgba(0, 0, 0, 0.55)',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#C9D6DB', // grey
  colorBorderPrimaryDark: '#d8d8d8', // grey2
  colorBorderSecondary: '#A47E25', // yellow
  colorBorderSemiDark: 'rgba(78, 122, 140, 0.3)',
  colorsDivider: '#EDF2F3', // outline

  // svg colors
  colorSvgSemidark: '#231F20',

  // Input
  colorInputBackground: '#1F2123',
  colorErrorMessage: '#f2545b',

  // Banner
  colorMisingInfoBackgorund: '#FFECB5',
  colorMissingInfoText: '#664D03',

  // Footer Colors
  colorFooterBackground: '#1F2123',
  colorFooterText: '#ffffff',
};

export const legacyPMFonts = `
@font-face {
  font-family: ${variables.family.legacyPM};
  src: url(${MontserratRegular}) format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: ${variables.family.legacyPM};
  src: url(${MontserratRegular}) format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: ${variables.family.legacyPM};
  src: url(${MontserratItalic}) format('woff2');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: ${variables.family.legacyPMHeaders};
  src: url(${Merriweather}) format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

h1,
h2,
h3,
h4,
h5,
h6,
h1 *,
h2 *,
h3 *,
h4 *,
h5 *,
h6 * {
  font-family: ${variables.family.legacyPMHeaders};
}

*,
*::after,
*::before {
  font-family: ${variables.family.legacyPM};
}


`;

export const legacyPMDefaultFonts = `
  @font-face {
    font-family: "Segoe UI";
    src: local("Segoe UI Bold");
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI";
    src: local("Segoe UI Semibold");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family:"Segoe UI";
    src: local("Segoe UI");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI";
    src: local("Segoe UI");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  *,
  *::after,
  *::before {
    font-family: "Segoe UI";
  }
`;
